// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GeneralView" + "." + "76716a685996ffde574d" + ".js";
};